import {FuncKeywordDefinition} from "ajv";

const def: FuncKeywordDefinition = {
    keyword: "nfHidden",
    schemaType: "object",
    valid: true
};

export default def;
